import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom'
import App from './App';

class MainRouter extends Component {
  render() {
    return (
          <BrowserRouter basename='/app'>
            <App />
          </BrowserRouter>
    );
  }
}

export default MainRouter;



// WEBPACK FOOTER //
// ./src/MainRouter.jsx